import { GenericTable, Modal, NewButton, NewButtonVariant } from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { modalTypes } from "constants/types";
import { arrayOf, number, shape, string } from "prop-types";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import {
  exportPipelineValueByCustomerCsv,
  exportPipelineValueByCustomerPdf,
} from "slices/pipelineValueByCustomer/actions";
import { formatCompactCurrency } from "utils/currency";

import { createColumns } from "./columns";
import styles from "./PipelineValueByCustomerModal.module.scss";

const MODAL_TITLE = "Pipeline Value by Customer";

const PipelineValueByCustomerModal = ({ data }) => {
  const dispatch = useDispatch();

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.PIPELINE_VALUE_BY_CUSTOMER));
  };

  const { totalValue, currency, customers = [] } = data;

  const customerCountLabel =
    customers.length === 1 ? "1 customer" : `${customers.length} customers`;

  const columns = useMemo(() => createColumns(currency), [currency]);

  return (
    <Modal
      backdrop
      centered
      className={`fade-in ${styles.modal}`}
      onDismiss={onDismiss}
      show
      size="lg"
    >
      <Modal.Header>{MODAL_TITLE}</Modal.Header>

      <Modal.Body>
        <div className={styles.pipelineValueByCustomerModal}>
          <p className={styles.pipelineValueByCustomerModal__subHeader}>
            {customerCountLabel} · {formatCompactCurrency(totalValue, currency)}{" "}
            total pipeline value
          </p>

          <div className={styles.pipelineValueByCustomerModal__tableWrapper}>
            <GenericTable
              className={styles.pipelineValueByCustomerModal__table}
              columns={columns}
              data={customers}
            />
          </div>
          <Flex justifyContent="flex-end" gap={GAP_CLASS.GAP_200}>
            <NewButton
              disabled={customers.length === 0}
              onClick={() => dispatch(exportPipelineValueByCustomerCsv())}
              variant={NewButtonVariant.l2}
            >
              Export CSV
            </NewButton>
            <NewButton
              disabled={customers.length === 0}
              onClick={() => dispatch(exportPipelineValueByCustomerPdf())}
              variant={NewButtonVariant.l1}
            >
              Export PDF
            </NewButton>
          </Flex>
        </div>
      </Modal.Body>
    </Modal>
  );
};

PipelineValueByCustomerModal.propTypes = {
  data: shape({
    totalValue: number.isRequired,
    totalOpportunityCount: number,
    currency: string.isRequired,
    customers: arrayOf(
      shape({
        customerName: string.isRequired,
        value: number.isRequired,
        opportunityCount: number,
        percentageOfTotal: number.isRequired,
        currency: string,
      })
    ).isRequired,
  }).isRequired,
};

export default PipelineValueByCustomerModal;
